import { render, staticRenderFns } from "./enrollment.vue?vue&type=template&id=4bef4e54&"
import script from "./enrollment.vue?vue&type=script&lang=js&"
export * from "./enrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports